var MDB = window.MDB || {};;
MDB.MyAvg = MDB.MyAvg || {};
MDB.MyAvg.Export = MDB.MyAvg.Export || {};

(function() {
    $.extend(MDB.MyAvg.Export, {
        boot: function () {
            $('.project-checkbox').on('change', function (e, isSystemEvent) {
                if (isSystemEvent) {
                    return;
                }

                var checked = this.checked;
                var container = $(this).closest('.project-container');

                var allProjectCheckboxes = container.find('.project-checkbox');
                var checkedProjectCheckboxes = allProjectCheckboxes.filter(':checked');
                var allCheckbox = container.find('.project-checkbox-all');

                if (checked) {
                    if (checkedProjectCheckboxes.length === allProjectCheckboxes.length) {
                        if (allCheckbox.is(':not(:checked)')) {
                            allCheckbox.trigger('click', [true]);
                        }
                    }
                } else {
                    if (checkedProjectCheckboxes.length !== allProjectCheckboxes.length) {
                        if (allCheckbox.is(':checked')) {
                            allCheckbox.trigger('click', [true]);
                        }
                    }
                }
            });

            $('.project-checkbox-all').on('change', function (e, isSystemEvent) {
                if (isSystemEvent) {
                    return;
                }

                var checked = this.checked;
                var container = $(this).closest('.project-container');

                var allProjectCheckboxes = container.find('.project-checkbox');
                var checkedProjectCheckboxes = allProjectCheckboxes.filter(':checked');
                var uncheckedProjectCheckboxes = allProjectCheckboxes.filter(':not(:checked)');
                
                var toggledCheckboxes;

                if (checked) {
                    if (checkedProjectCheckboxes.length !== allProjectCheckboxes.length) {
                        toggledCheckboxes = uncheckedProjectCheckboxes;
                    }
                } else {
                    if (checkedProjectCheckboxes.length === allProjectCheckboxes.length) {
                        toggledCheckboxes = checkedProjectCheckboxes;
                    }
                }
                
                if (toggledCheckboxes) {
                    toggledCheckboxes.trigger('click', [true]);
                }
            });
        }
    });
})();